import StoreInfoForm from './StoreInfoForm';

export default StoreInfoForm;
